import { render, staticRenderFns } from "./selectOpenStorageModal.vue?vue&type=template&id=0a5a5b94&"
import script from "./selectOpenStorageModal.vue?vue&type=script&lang=ts&"
export * from "./selectOpenStorageModal.vue?vue&type=script&lang=ts&"
import style0 from "./selectOpenStorageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports